// CNPJ alfanumerico (IN RFB 2.229/2024): 12 primeiras posicoes [A-Z0-9], 2 ultimas numericas
export const CNPJ_MASK = {
  mask: 'CC.CCC.CCC/CCCC-99',
  definitions: {
    'C': {
      validator: '[A-Za-z0-9]',
      casing: 'upper',
      cardinality: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/masks.js